import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {User} from '../models/user-model';
import {concatMap, skipWhile} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService implements OnDestroy {
  private readonly userSubject: BehaviorSubject<User> = new BehaviorSubject<User>(undefined);
  public readonly user$: Observable<User> = this.userSubject.asObservable();

  private userSubscribtion: Subscription;

  constructor() {
    this.init();

    this.userSubscribtion = this.user$
      .pipe(
        skipWhile(u => !u),
        concatMap(u => {
          if (u) {
            localStorage.setItem('user', JSON.stringify(u))
          } else {
            localStorage.removeItem('user')
          }
          return [];
        })
      ).subscribe(e => {
      });
  }

  ngOnDestroy(): void {
    this.userSubscribtion.unsubscribe();
  }

  public async init() {
    const user = JSON.parse(localStorage.getItem('user')) as User;
    this.userSubject.next(user);
  }

  public setUser(user: User): void {
    this.userSubject.next(user);
  }

  public get user() {
    return this.userSubject.value;
  }

}
